import { Ancillary } from '@tff/types/tff';

export const checkNonAtcomAncillaries = (ancillaries: Record<string, Ancillary> | undefined | null): boolean => {
  if (!ancillaries) return false;
  const ancillariesList: Ancillary[] = Object.values(ancillaries);
  return ancillariesList.filter(a => a.Type !== 'SEAT').some(a => !a.Note || a.Note !== 'ATCOM');
};
